// extracted by mini-css-extract-plugin
export var section = "careers-module--section--NJd0Q";
export var inner = "careers-module--inner--3LTfq";
export var jsInitAnim = "careers-module--jsInitAnim--2YhyW";
export var content = "careers-module--content--2-GeG";
export var title = "careers-module--title--3P4Fe";
export var description = "careers-module--description--hWk8I";
export var imgWrap = "careers-module--imgWrap--Y9DRP";